import { Button, Form } from 'antd';
import TextArea from 'antd/lib/input/TextArea';

import { useSendMessageMutation } from 'app/services/edpApiV1/consultations';

import style from './index.module.scss';

const SendMessage = ({ id }: { id: string | undefined }) => {
  const [form] = Form.useForm();
  const [sendMessageTrigger] = useSendMessageMutation();

  const onFinish = (value: { text: string }) => {
    const { text } = value;
    if (id) {
      sendMessageTrigger({
        chatId: Number(id),
        text,
      });
      form.resetFields();
    }
  };

  return (
    <div className={style.wrap}>
      <Form form={form} onFinish={onFinish}>
        <Form.Item
          name="text"
          rules={[
            {
              required: true,
              message: 'Пожалуйста, введите текст',
            },
          ]}
          normalize={value => value.replace(/^\s+/g, '')}
        >
          <TextArea rows={4} placeholder="Введите текст" maxLength={2000} minLength={2} />
        </Form.Item>
        <Button type="primary" htmlType="submit">
          Отправить
        </Button>
      </Form>
    </div>
  );
};

export default SendMessage;
